module.exports = __webpack_public_path__ + "img/penguin.552b83b3.gif";